import { FieldLabel } from "./FieldLabel";
import { fieldBase, fieldStyle, applyFocus, applyBlur } from "./fieldStyles";

export function FormField({
  label,
  name,
  type = "text",
  required,
  index,
  testId,
}) {
  return (
    <div>
      <FieldLabel htmlFor={name} required={required} index={index}>
        {label}
      </FieldLabel>
      <input
        id={name}
        name={name}
        type={type}
        required={required}
        data-testid={testId}
        className={fieldBase}
        style={fieldStyle}
        onFocus={applyFocus}
        onBlur={applyBlur}
      />
    </div>
  );
}
